import * as React from "react";
import IndexHeader from "app/shared-components/IndexHeader";
import CustomButton from "app/shared-components/CustomColorButton";

import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import history from "@history";
import AdminTransferFormFilter from "./components/AdminTransferFormFilter";
import AdminTransferFormList from "./components/AdminTransferFormTable";

  const handleClick = () => {
    history.push('transfer-form/add');
  };


export default function AdminWorksiteIndex() {
 
  return (
    <>
      <IndexHeader
        name={"Admin Transfer Forms"}
        update={false}
        add={false}
      />
      <AdminTransferFormFilter />
      <AdminTransferFormList />
    </>
  );
}
